import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CaretRightIcon } from '@yonderland/andes-icons';
import { ButtonLink, Icon } from '@yonderland/andes-react';
export const ProductSustainabilityTabCTA = ({ url, text }) => (_jsxs(ButtonLink, { variant: "secondary", fullWidth: true, href: url, children: [text, _jsx(Icon, { source: CaretRightIcon, size: "sm" })] }));
